export default __webpack_public_path__ + "static/media/atlantic-council-logo.a0321877.png";